import { Inject, Injectable } from '@angular/core';
import { CommonInfoService } from '../../cart-process/common-info.service';
import { PriceTypeEnum } from '../../models/cartDetails/priceType.model';
import { AgreementsService } from './agreements.service';
import { CommonModalService } from '../../utils/modals/common-modal.service';
import { IPriceSet } from '../../interfaces/cart-details.interface';
import { CommonModalTemplatesEnum } from '../../utils/modals/common-modal-templates.enum';

@Injectable()
export class SelectedAgreementsService {

  private isPendingRequest = false;

  constructor(
    @Inject('Endpoint') private endpoint: any,
    private commonModalService: CommonModalService,
    private commonInfo: CommonInfoService,
    private agreementsService: AgreementsService,
  ) {}

  public areAgreementsAvailable(): boolean {
    return !!this.agreementsService.agreementsGroupsLength;
  }

  public checkAgreements(): Promise<any> {
    if (this.isPendingRequest) {
      return this.checkAgreements['cache'];
    }

    this.isPendingRequest = true;

    this.checkAgreements['cache'] = new Promise((resolve, reject) => {

      this.endpoint('newCart.checkAgreements')
        .run()
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error);
        });

    });

    return this.checkAgreements['cache'];
  }

  public startUnlimitedGbModal(checkAgreementsResponse: any, submitCallback: Function) {
    const modalData = checkAgreementsResponse;

    modalData.templateName = CommonModalTemplatesEnum.AGREEMENTS_UNLIMITED_GB_MODAL;

    modalData.finishProcess = ($event: MouseEvent) => {
      $event.preventDefault();

      this.isPendingRequest = false;

      this.commonModalService.removeModal(CommonModalTemplatesEnum.AGREEMENTS_UNLIMITED_GB_MODAL);

    };

    modalData.submitPage = ($event: MouseEvent) => {
      $event.preventDefault();

      submitCallback();
    };

    this.commonModalService.setData(modalData);
  }

  public startMarketingModal(checkAgreementsResponse: any, submitCallback: Function) {
    const modalData = checkAgreementsResponse;

    modalData.templateName = CommonModalTemplatesEnum.MODAL_CHECK_AGREEMENTS_COMPLETE;

    modalData.agreementPriceText = checkAgreementsResponse.text1;
    modalData.notAgreementPriceText = checkAgreementsResponse.text2;

    modalData.getPrice = (price: any) => {
      return price.price[this.commonInfo.taxName];
    };

    modalData.monthlyPrices = this.findMonthlyPrices(modalData.prices);
    modalData.monthlyDiscountPrices = this.findMonthlyPrices(modalData.discountPrices);

    modalData.finishProcess = ($event: MouseEvent) => {
      $event.preventDefault();

      this.isPendingRequest = false;

      this.commonModalService.removeModal(CommonModalTemplatesEnum.MODAL_CHECK_AGREEMENTS_COMPLETE);
    };

    modalData.submitPage = ($event: MouseEvent) => {
      $event.preventDefault();

      this.commonModalService.removeModal(CommonModalTemplatesEnum.MODAL_CHECK_AGREEMENTS_COMPLETE);

      submitCallback();
    };

    this.commonModalService.setData(modalData);
  }

  public isMarketingAgreements(checkAgreementResponse: any) {
    return (!checkAgreementResponse.invoiceAndMarketing && !checkAgreementResponse.invoiceOnly && !checkAgreementResponse.marketingOnly)
  }

  public isUnlimitedGbAgreements(checkAgreementResponse: any) {
    return checkAgreementResponse.unlimitedGb && this.isMarketingAgreements(checkAgreementResponse);
  }

  private findMonthlyPrices(pricesGroups: IPriceSet[]) {
    return pricesGroups.find((priceGroup: IPriceSet) => priceGroup.type === PriceTypeEnum.MONTHLY).prices;
  }
}
